<template>
  <div class="shipment-panel">
    <div class="shipment-chart">
      <div class="c-order-util-box">
        <div class="left-box">
          <div class="text-item">
            <strong>총 출고 제품 수(제품수량) : </strong>
            <span>
              {{ Number(data.biz1.totalCount).toLocaleString() }}건 ({{
                Number(data.biz1.totalSum).toLocaleString()
              }})
            </span>
          </div>
        </div>
        <div class="right-box">
          <div class="text-item">
            <span>
              {{ data.biz1.search.chartDateSt }} ~
              {{ data.biz1.search.chartDateEd }}
            </span>
          </div>
        </div>
      </div>
      <!-- D: 차트 영역(chart-box div 살려야합니다) -->
      <div class="chart-box">
        <canvas ref="chartCanvas"></canvas>
      </div>
      <!-- // D: 차트 영역(chart-box div 살려야합니다) -->
    </div>
    <div class="top-ranking">
      <div class="c-order-util-box">
        <div class="left-box">
          <div class="text-item">
            <strong> 카테고리별 Top 3 제품 </strong>
          </div>
        </div>
        <div class="right-box">
          <div class="c-select type-medium">
            <select v-model="data.biz2.selectedMonth">
              <option
                v-for="(item, index) in data.biz2.monthList"
                :key="index"
                :value="item"
              >
                {{ item }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="select-group flex-box">
        <div class="c-select type-triangle">
          <select v-model="data.biz2.search.prodh1">
            <option value="">시장구분</option>
            <option
              :value="item.clsfCd"
              v-for="(item, index) in data.biz2.prodh1List"
              :key="index"
            >
              {{ item.clsfNm }}
            </option>
          </select>
        </div>
        <div class="c-select type-triangle">
          <select v-model="data.biz2.search.prodh2">
            <option value="">브랜드</option>
            <option
              :value="item.clsfCd"
              v-for="(item, index) in data.biz2.prodh2List"
              :key="index"
            >
              {{ item.clsfNm }}
            </option>
          </select>
        </div>
        <div class="c-select type-triangle">
          <select v-model="data.biz2.search.prodh3">
            <option value="">제품군</option>
            <option
              :value="item.clsfCd"
              v-for="(item, index) in data.biz2.prodh3List"
              :key="index"
            >
              {{ item.clsfNm }}
            </option>
          </select>
        </div>
      </div>
      <template v-if="data.biz2.list.length > 0">
        <div class="list-box">
          <ol>
            <li
              class="item"
              v-for="(item, index) in data.biz2.list"
              :key="index"
            >
              <button type="button" class="btn" @click="openProdInfoPop(item)">
                <i class="num">{{ index + 1 }}</i>
                <span class="text">
                  {{ item.zzmaktx }}
                  <b>(수량 {{ Number(item.lfimgSum).toLocaleString() }})</b>
                </span>
              </button>
            </li>
          </ol>
        </div>
      </template>
      <template v-if="data.biz2.list.length < 1">
        <p class="c-no-data-panel">출고현황이 없습니다.</p>
      </template>
    </div>
  </div>
</template>
<script setup>
import { Chart } from "chart.js";
import {
  onMounted,
  onUnmounted,
  reactive,
  computed,
  inject,
  watch,
  defineEmits,
  ref,
  nextTick,
} from "vue";
import * as store from "@/store";
import * as cmApi from "@/api/cmApi";
import * as cmUtil from "@/utils/cmUtil.js";
const { isMobile } = cmUtil.useDeviceType();
import { api } from "@/plugins/api";

const url = inject("url_prefix");

const emit = defineEmits(["detail"]);
const todayDate = computed(() => {
  const now = new Date();
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  return now.toLocaleDateString("en-CA", options);
});

/***********************
 * 데이타 모음
 **********************/
const data = reactive({
  page: {
    token: "",
    isLogin: false,
    userLoginInfo: {},
    deviceType: isMobile.value ? "M" : "P",
    basketCount: {},
    empIndex: 0,
    selectedBranch: {},
  },
  codes: {
    code01: [],
    code02: [],
  },
  popup: {},
  biz1: {
    search: {
      wadatIstSt: "", // 시작 출고일자
      wadatIstEd: "", // 끝 출고일자
      searchQuery: "", // 검색어
      useYn: "Y",
      orderBy: "",
      chartDateSt: "",
      chartDateEd: "",
      resDateSt: "",
      resDateEd: "",
    },
    search_init: {}, // 검색 파라메터 초기값
    list: [], // 목록
    page: 0, // 현재 페이지
    limit: 20, // 목록 조회 행수
    totalCount: 0,
    totalPage: 0,
    totalSum: 0,
    chartRangeYear: [],
    chartRangeMonth: [],
    chartData: [],
    yearMonth: "",
    loading: false,
  },
  biz2: {
    monthList: [],
    selectedMonth: "",
    search: {
      wadatIst: "", // 출고일자 'yyyy-MM'
      matkl: "", // 제품분류코드
      prodh1: "", // 시장구분
      prodh2: "", // 브랜드
      prodh3: "", // 대표제품군
    },
    list: [],
    prodh1List: [],
    prodh2List: [],
    prodh3List: [],
  },
  eventBus: {
    salesPersonIndex: 0,
  },
});

let chartInstance = null;
const chartCanvas = ref(null);

/**********************
 * 마운트
 *********************/
onMounted(() => {
  pageInit(); // 페이지 초기화 호출
});

onUnmounted(() => {
  destroyChart();
});

/*********************
 * 페이지 초기함
 *********************/
async function pageInit() {
  await pageInitData();
  await searchCmd("biz1#graph"); // 출고현황 그래프 데이터
  await nextTick();
  createGraph(); // 출고현황 그래프
  data.biz2.prodh1List = await searchCmd("biz2#code", {
    upClsfCd: data.page.selectedBranch?.matkl,
  }); // 상위 TOP3 제품 시장구분
}

/**********************
 * 페이지 초기 데이타 조회
 *********************/
async function pageInitData() {
  // ◼◼◼ 초기데이타 조회
  const mparm = [];
  const res = await cmApi.getPageInitData(mparm);
  const { resultCode } = res;
  if (resultCode !== 200) {
    //alert(`errror : resultCode:${resultCode}, message:${message} `);
    return false;
  }

  data.page.token = cmUtil.getLocalStorage("token");
  data.page.isLogin = store.useAuthStore()?.user ? true : false;
  data.page.userLoginInfo = store.useAuthStore()?.user;

  // 상위제품 연,월
  data.biz2.monthList = getLast12Months();
  data.biz2.selectedMonth = data.biz2.monthList[0];
  data.biz2.search.wadatIst = data.biz2.selectedMonth;

  // 영업사원 디폴트
  data.page.empIndex = store.useEventBusStore()?.salesPersonIndex;
  data.page.selectedBranch =
    data.page.userLoginInfo.empList[data.page.empIndex];
  data.biz2.search.matkl = data.page.selectedBranch.matkl;

  dateCalculation("defaultYear", "chart");

  // ◼◼◼ 초기데이타 백업
  data.biz1.search_init = { ...data.biz1.search };
}

/**********************
 * 조회 모음
 *********************/
async function searchCmd(cmd = "", parms = {}) {
  if (cmd === "biz1#graph") {
    const res = await api.get(`${url}/order/selectShipmentGraph`);
    const { totalCount, totalSum } = res.data.find(
      (item) => item.wadatIstYear == null
    );
    data.biz1.totalCount = totalCount;
    data.biz1.totalSum = totalSum;
    data.biz1.list = res.data.filter((item) => item.wadatIstYear != null);
    data.biz1.chartRangeYear = data.biz1.list.map((item) => item.wadatIstYear);
    data.biz1.chartRangeMonth = data.biz1.list.map(
      (item) => item.wadatIstMonth
    );
    data.biz1.chartData = data.biz1.list.map((item) => {
      return {
        x: item.wadatIstMonth,
        y: item.totalCount,
        year: item.wadatIstYear,
        sum: item.totalSum,
      };
    });
    if (isMobile.value) {
      data.biz1.chartRangeYear = data.biz1.chartRangeYear.slice(-6);
      data.biz1.chartRangeMonth = data.biz1.chartRangeMonth.slice(-6);
      data.biz1.chartData = data.biz1.chartData.slice(-6);
    }
  } else if (cmd === "biz2#search") {
    const res = await api.get(`${url}/order/selectShipmentTopProd`, {
      params: { ...data.biz2.search },
    });
    data.biz2.list = res.data;
  } else if (cmd === "biz2#code") {
    if (parms.upClsfCd != "") {
      const res = await api.get(`${url}/order/selectPrdctUpClsfCd`, {
        params: { upClsfCd: parms.upClsfCd },
      });
      return res.data;
    }
  } else {
    alert(`[개발확인] searchCmd() cmd [${cmd}] 를 확인해주세요` + parms);
    return false;
  }
}

// 제품 상세 팝업
function openProdInfoPop(item) {
  emit("detail", item);
}

// 검색 기간 계산
async function dateCalculation(period, type) {
  const today = new Date();
  let resultDate = new Date(today);

  switch (period) {
    case "today":
      resultDate.setDate(today.getDate());
      break;
    case "month":
      resultDate.setDate(today.getDate() - 29);
      break;
    case "half-year":
      resultDate.setDate(today.getDate() - 179);
      break;
    case "year":
      resultDate.setDate(today.getDate() - 364);
      break;
    case "defaultYear":
      resultDate.setDate(today.getDate() - 364);
      //resultDate.setDate(1);
      break;
    default:
      await cmUtil.alert("알 수 없는 기간입니다.");
      return null;
  }

  // YYYY-MM-DD 형식으로 변환
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };

  resultDate = resultDate.toLocaleDateString("en-CA", options);

  if (type == "chart") {
    var year = resultDate.substring(0, 4);
    var month = resultDate.substring(5, 7);

    if (isMobile.value) {
      month = Number(month) + 7;
    } else {
      month++;
    }

    if (month > 12) {
      year = year + 1;
      month = 1;
    }

    if (("" + month).length == 1) {
      month = "0" + month;
    }

    data.biz1.search.chartDateSt = "" + year + "-" + month + "-" + "01";
    data.biz1.search.chartDateEd = todayDate.value;
  } else {
    data.biz1.search.wadatIstSt = resultDate;
    data.biz1.search.wadatIstEd = todayDate.value;
  }
}

// 오늘기준 12개월 리스트
function getLast12Months() {
  const currentDate = new Date();
  const monthsList = [];

  for (let i = 0; i < 12; i++) {
    const monthDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() - i,
      1
    );
    monthsList.push(
      `${monthDate.getFullYear()}-${String(monthDate.getMonth() + 1).padStart(2, "0")}`
    );
  }

  return monthsList;
}

// GNB 영업사원 리스트 연동
watch(
  () => store.useEventBusStore()?.salesPersonIndex,
  async (newValue) => {
    data.eventBus.salesPersonIndex = newValue;
    if (newValue >= 0 && data.page.userLoginInfo?.empList?.length > newValue) {
      data.page.empIndex = newValue;
      data.page.selectedBranch =
        data.page.userLoginInfo.empList[data.page.empIndex];
      data.biz2.search.matkl = data.page.selectedBranch?.matkl;
      await searchCmd("biz2#search");
    }
  }
);

// 상위제품 기간변경시
watch(
  () => data.biz2.selectedMonth,
  async (newValue) => {
    data.biz2.search.wadatIst = newValue;
    await searchCmd("biz2#search");
  }
);

// 시장구분 선택시
watch(
  () => data.biz2.search.prodh1,
  async (newValue) => {
    if (newValue == "") {
      data.biz2.search.prodh2 = "";
      data.biz2.prodh2List = [];
    } else {
      data.biz2.search.prodh2 = "";
      data.biz2.prodh2List = await searchCmd("biz2#code", {
        upClsfCd: newValue,
      });
      await searchCmd("biz2#search");
    }
  }
);

// 브랜드 선택시
watch(
  () => data.biz2.search.prodh2,
  async (newValue) => {
    if (newValue == "") {
      data.biz2.search.prodh3 = "";
      data.biz2.prodh3List = [];
    } else {
      data.biz2.search.prodh3 = "";
      data.biz2.prodh3List = await searchCmd("biz2#code", {
        upClsfCd: newValue,
      });
      await searchCmd("biz2#search");
    }
  }
);

// 대표제품군 선택시
watch(
  () => data.biz2.search.prodh3,
  async () => {
    await searchCmd("biz2#search");
  }
);

// 출고현황 그래프
function createGraph() {
  destroyChart();
  if (!chartCanvas.value) {
    return;
  }
  const ctx = chartCanvas.value.getContext("2d"); // PC
  if (!ctx) {
    return;
  }

  try {
    const gradient = ctx.createLinearGradient(0, 0, 0, 300);
    gradient.addColorStop(0, "rgba(0, 125, 108, 0.3)");
    gradient.addColorStop(1, "rgba(255, 255, 255, 0)");
    chartInstance = new Chart(ctx, {
      type: "line",
      data: {
        labels: data.biz1.chartRangeMonth,
        datasets: [
          {
            data: data.biz1.chartData,
            titleColor: "#000000",
            borderColor: "rgba(0, 125, 108, 0.5)",
            backgroundColor: gradient,
            fill: true,
            tension: 0,
            borderWidth: 3,
            pointRadius: 3,
            pointBackgroundColor: "#007D6C",
            pointBorderWidth: 0,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: isMobile.value
            ? {
                // 250408 변경
                top: 60,
                left: 23,
                right: 23,
                bottom: 50,
              }
            : {
                // 250408 변경
                top: 40,
                left: 40,
                right: 40,
                bottom: 40,
              },
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            position: "average",
            yAlign: "bottom",
            caretPadding: 10,
            backgroundColor: "#FFECEC",
            titleColor: "#FF7A7A",
            bodyColor: "#FF7A7A",
            borderColor: "#FFCECE",
            borderWidth: 1,
            padding: 6,
            displayColors: false,
            titleFont: {
              weight: "bold",
            },
            bodyFont: {
              weight: "bold",
            },
            callbacks: {
              title: function (context) {
                const month = context[0].label;
                const year = context[0].raw.year;
                return `${year}년 ${month}월`;
              },
              label: function (context) {
                const value = context.raw;
                return `${value.y}건(${value.sum})`;
              },
            },
          },
        },
        scales: {
          x: {
            grid: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              maxRotation: 0,
              minRotation: 0,
              autoSkip: true,
              autoSkipPadding: 10,
              color: "#000000",
              font: {
                size: 15,
              },
            },
          },
          y: {
            // 250408 y축 옵션 변경
            beginAtZero: true,
            border: {
              display: false,
            },
            ticks: {
              color: "#000000",
            },
          },
        },
        onClick(event, chartElement) {
          if (chartElement.length > 0) {
            const clickedData = chartElement[0].element.$context.raw;
            store
              .useShipmentListStore()
              .setParam({ year: clickedData.year, month: clickedData.x });
            store.useShipmentListStore().excuteSearchFunction();
          }
        },
      },
    });
  } catch (error) {
    console.log("chart", error);
  }
}

function destroyChart() {
  if (chartInstance) {
    try {
      chartInstance.destroy();
      chartInstance = null;
    } catch (error) {
      console.log("destroyChart", error);
    }
  }
}
</script>
